import React, { useState } from "react";
import api from '../../../../../api'; 

const Contact = ({ data }) => {
    const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "" });
    const [status, setStatus] = useState({ loading: false, message: "", type: "" });

    if (!data) return null;

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let filteredValue = value;

        // --- Frontend Real-time Validation Logic ---
        if (name === "name") {
            // Allow only Alphabets and Space
            filteredValue = value.replace(/[^A-Za-z\s]/g, "");
        } else if (name === "phone") {
            // Allow only Numeric, No Space
            filteredValue = value.replace(/[^0-9]/g, "");
        } else if (name === "email") {
            // Don't allow space
            filteredValue = value.replace(/\s/g, "");
        }

        setFormData({ ...formData, [name]: filteredValue });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ loading: true, message: "", type: "" });

        try {
            const response = await api.post("/api/intern-care/submit", formData);
            if (response.data.status) {
                setStatus({ loading: false, message: "Message sent successfully!", type: "success" });
                setFormData({ name: "", email: "", phone: "", message: "" }); // Reset form

                // ✅ Clear success message after 5 seconds
                setTimeout(() => {
                    setStatus({ loading: false, message: "", type: "" });
                }, 5000);
            }
        } catch (error) {
            // Capture specific Laravel validation errors if available
            const errorMsg = error.response?.data?.message || "Something went wrong. Please try again.";
            setStatus({ loading: false, message: errorMsg, type: "danger" });

            // ✅ Clear error message after 5 seconds
            setTimeout(() => {
                setStatus({ loading: false, message: "", type: "" });
            }, 5000);
        }
    };

    const formatContactText = (text) => {
        if (!text) return "";
        if (text.includes("@")) return <a href={`mailto:${text}`} className="contact-link">{text}</a>;
        if (/^\+?\d[\d\s\-]{6,}$/.test(text)) return <a href={`tel:${text.replace(/\s+/g, "")}`} className="contact-link">{text}</a>;
        if (text.startsWith("http")) return <a href={text} target="_blank" rel="noopener noreferrer" className="contact-link">{text}</a>;
        return (
            <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer" className="contact-link">
                {text}
            </a>
        );
    };

    return (
        <section className="contact-section">
            <div className="container my-4">
                <div className="sec-title text-center mb-4">
                    <h2>Contact Us</h2>
                </div>

                <div className="row g-4">
                    <div className="col-lg-7">
                        <div className="contact-form p-4 shadow-sm rounded bg-white h-100">
                            <h4 className="mb-3 text-center">Get in Touch</h4>
                            
                            {/* Alert Message */}
                            {status.message && (
                                <div className={`alert alert-${status.type} text-center`} role="alert">
                                    {status.message}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className="mb-2">
                                    <label className="form-label">Full Name <span className="text-danger">*</span></label>
                                    <input 
                                        type="text" 
                                        name="name" 
                                        className="form-control" 
                                        value={formData.name} 
                                        onChange={handleInputChange} 
                                        maxLength="50" 
                                        placeholder="Enter Full Name"
                                        required 
                                    />
                                </div>

                                <div className="mb-2">
                                    <label className="form-label">Email <span className="text-danger">*</span></label>
                                    <input 
                                        type="email" 
                                        name="email" 
                                        className="form-control" 
                                        value={formData.email} 
                                        onChange={handleInputChange} 
                                        maxLength="75"
                                        placeholder="Enter Email"
                                        required 
                                    />
                                </div>

                                <div className="mb-2">
                                    {/* Phone Label with Red Asterisk specifically styled */}
                                    <label className="form-label">Contact No <span style={{color: 'red'}}>*</span></label>
                                    <input 
                                        type="text" 
                                        name="phone" 
                                        className="form-control" 
                                        value={formData.phone} 
                                        onChange={handleInputChange} 
                                        maxLength="12"
                                        placeholder="Enter Mobile Number"
                                        required 
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Message <span className="text-danger">*</span></label>
                                    <textarea 
                                        name="message" 
                                        className="form-control" 
                                        rows="3" 
                                        value={formData.message} 
                                        onChange={handleInputChange} 
                                        required 
                                        placeholder="Enter Message"
                                    />
                                </div>

                                <div className="text-center mt-4">
                                    <button type="submit" className="submit-btn" disabled={status.loading}>
                                        {status.loading ? "Sending..." : "Submit"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-5">
                        <div className="row g-3">
                            {data.items && data.items.map((item, index) => (
                                <div className="col-6" key={index}>
                                    <div className="contact-card text-center p-3 shadow-sm rounded bg-white h-100">
                                        {item.logo && (
                                            <img src={item.logo} alt={item.heading} className="img-icon mb-2" style={{ width: "40px", height: "40px" }} />
                                        )}
                                        <p className="fw-bold" style={{ color: "var(--thm-bg)" }}>{item.heading}</p>
                                        <p className="mb-0">{formatContactText(item.contact_info)}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="row mt-3">
                            <div className="col-12">
                                <iframe src={data.map_url} height="350" style={{ width: "100%", border: 0 }} loading="lazy" title="Location Map" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;